import React from 'react';
import PageLayout from '../components/PageLayout';

/**
 * Careers page component
 */
const CareersPage: React.FC = () => {
  return (
    <PageLayout 
      title="Join Our Team" 
      subtitle="Help us revolutionize how golfers book tee times"
      backgroundImage="https://images.pexels.com/photos/1325750/pexels-photo-1325750.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <section>
        <h2>Work With Us</h2>
        <p>
          At GolfScape, we're building a team of passionate individuals who share our love for golf and technology.
          We offer competitive benefits, flexible remote work options, and a collaborative environment where your
          ideas and contributions matter.
        </p>
      </section>
      
      <section>
        <h2>Open Positions</h2>
        <div className="content-card">
          <h3>Full Stack Developer</h3>
          <p><strong>Location:</strong> Remote (US-based)</p>
          <p><strong>Department:</strong> Engineering</p>
          <p>
            We're looking for an experienced Full Stack Developer to join our engineering team and help build the next
            generation of our tee time booking platform. The ideal candidate will have experience with React, TypeScript,
            and Node.js.
          </p>
          <button className="form-submit">Apply Now</button>
        </div>
        
        <div className="content-card" style={{ marginTop: '2rem' }}>
          <h3>Golf Partnership Manager</h3>
          <p><strong>Location:</strong> Scottsdale, AZ (Hybrid)</p>
          <p><strong>Department:</strong> Business Development</p>
          <p>
            We're seeking a Golf Partnership Manager to build and maintain relationships with golf courses and help
            expand our network of partners. The ideal candidate will have experience in the golf industry and a passion
            for growing the game.
          </p>
          <button className="form-submit">Apply Now</button>
        </div>
      </section>
    </PageLayout>
  );
};

export default CareersPage;
